export default "__VITE_ASSET__CSjQu6WF__"